<div class="cards">
  <div  *ngFor="let card of queAns;let i = index;">    
    <div class="que-card pad-15" @fadeIn *ngIf="card.isDeleted===false||card.isDeleted==null">
      <div class="flex cp align-center justify-between"
           (click)="expandSectionCard(card)"
           [ngClass]="{'que-expanded': card.isExpanded}" *ngIf="!isEditing">
        <input type="text" aria-label="Text" autocomplete="off" [(ngModel)]="card.sectionName" (focusout)="updateData()" name="title" placeholder="Insert Section Title" />
    
        <fa-icon [icon]="card.isExpanded ? icons.faChevronUp : icons.faChevronDown"></fa-icon>
      </div>
      <div  class="flex cp align-center justify-between"   [ngClass]="{'que-expanded': card.isExpanded}"  *ngIf="card.isExpanded || isEditing">
        <input type="text" aria-label="Text" autocomplete="off" [(ngModel)]="card.sectionDescription" (focusout)="updateData()" name="title" placeholder="Insert Section Description" />
      </div>
      <div *ngIf="isEditing">
        <h3> {{card.sectionName}} </h3>
      </div>
      <div class="card-expanded" *ngIf="card.isExpanded || isEditing">
        <div *ngFor="let que of card.questions;let j = index;">            
          <div class="que-option cp" [ngClass]="{'expanded': que.isExpanded || isEditing}"  *ngIf="que.isDeleted===null||que.isDeleted==false" @fadeIn>
            <ng-container [ngTemplateOutlet]="
            que.dataType === 'textbox'? textbox : 
            que.dataType === 'textarea'? textarea : 
            que.dataType === 'dte' ? dte :
            (que.dataType === 'multipleChoice' || que.dataType === 'checkbox' || que.dataType === 'radiobuttons' || (que.dataType === 'dropdown' && !isEditing)) ? multipleChoice :
            que.dataType === 'welcome' ? welcome :
            que.dataType === 'thankyou' ? thankyou :
            que.dataType === 'rating' ? rating :
            que.dataType === 'table' ? gridRender :
            que.dataType==='signature'?signature:
            que.dataType==='fileupload'?fileupload: 
            que.dataType==='matrix'?matrix:      
            (que.dataType === 'dropdown' && isEditing) ? dropdown : ''"
            [ngTemplateOutletContext]="{que: que, card: card, questions: card.questions, rowNumber: j,isGrid:false,gridId:0}">
            </ng-container>
          </div>
           
       </div>
       
        <div  class="que-option add-question flex justify-between" *ngIf="!isEditing">
          <fa-icon class="cp" (click)="toggleQuestionType(card)" [icon]="icons.faPlus"></fa-icon>
          <button type="button" title="DELETE" class="delete-btn cp" (click)="deleteQuestion(i)">DELETE</button>
          <div id="myModal" class="modal" [ngStyle]="{'display': card.isMenuVisible && IsQuestionMenu? 'block' : 'none'}">
          <div style="position: relative !important;" class="dropdown  modal-content" (mouseleave)="toggleQuestionType(card)">
            <div class="flex">
              <div class="que-types">
                <p id="title" style="margin:0px"><strong>Choose A Question Type</strong></p>
                <ul class="ulflex">
                  <li class="flex align-center liflex" *ngFor="let type of queTypes;"
                      (mouseenter)="setQuestionContent(type)"
                      (click)="addNewQuestion(card.questions,card)">
                    <span [ngStyle]="{'background-color': type.colorCode}"> {{type.icon}} </span>
                    <span> {{type.title}} </span>
                  </li>
                </ul>
              </div>
            
            </div>
          </div>
          </div>
        </div>
      </div>
      <div *ngIf="card.questions.length>0">
        <button title="Duplicate" style="background-color:#287cc4;float:right;width:75px;height:25px;border-radius: 5px;border:none;color:#fff;" type="button" (click)="DuplicateSection(queAns,card);">
          Duplicate
        </button>
        <br>        
      </div>
    </div>
    
  </div>
  <div class="dvConsent" *ngIf="IsESignQuesTypeAdded">
    <div style="width: 100%;display: contents;">
      <label style="width: 20%;margin: 1%;">E-Signature Consent </label>
      <textarea style="width: 80%;min-height: 50px;margin: 5px;float: right;font-size: small;font-family: verdana, sans-serif;"  [(ngModel)]="esignConsenttext" class="esignConsent" placeholder="Please type consent statement for providing E-Signature" ></textarea>
    </div>
    </div>


  <div class="add-section" *ngIf="!isEditing" style="margin-top:15px;">
    <div>
      <button type="button" title="ADD SECTION" style="width: 110px;" class="cp" (click)="addNewSection(queAns)">
        <fa-icon [icon]="icons.faPlus" size="sm"></fa-icon>
        SECTION
      </button>
    </div>
    <div class="publish"  style="margin-top:15px;">
      <button type="button"  title="SAVE" style="width: 110px;cursor: pointer;" (click)="SaveConf()">
        SAVE
      </button>
    </div>
    <div class="publish" style="margin-top:15px;">
      <button title="PUBLISH" style="background-color:#7ac142;width: 110px;cursor: pointer;" type="button" (click)="publish('S')">
        PUBLISH
      </button>
    </div>
  </div>
</div>
<ng-template #textbox let-que="que" let-questions="questions" let-rowNumber="rowNumber" let-card="card" let-isGrid="isGrid" let-gridId="gridId">
  <div (onfocus)="expandCard(que,card)" class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" aria-label="Text" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
  </div>
  <div *ngIf="que.dataType == 'textbox' && isEditing" class="input-preview">
 <input placeholder="Enter answer" [(ngModel)]="que.answer" name="answer" />
   </div>
  <ul *ngIf="que.isExpanded && !isEditing">
    <div class="images flex" *ngIf="que.images?.length > 0">
      <div class="flex" *ngFor="let imgURL of que.images; let ind = index;">
        <img *ngIf="que.questionImage" [src]="imgURL" width="50" alt="" />
        <fa-icon class="cp" [icon]="icons.faTimes" (click)="removeItems(que.images, ind,card,isGrid,gridId)"></fa-icon>
      </div>
    </div>
    <li class="flex align-center justify-end">
      <div class="p-rel">
        <!-- <fa-icon class="cp" [icon]="icons.faImage"></fa-icon> -->
        <input #file type="file" accept='image/*' (change)="preview(que, file.files)" />
        <fa-icon class="cp" [icon]="icons.faEllipsisH" (click)="toggleEditQuestion(que)"></fa-icon>
        <div class="dropdown createQuestion" (mouseleave)="toggleEditQuestion(que)" *ngIf="que.editQuestion">
          <ul>
            <li (click)="duplicateQuestion(que, questions)">
              <fa-icon class="cp" [icon]="icons.faClone"></fa-icon>
              Duplicate
            </li>
            <li (click)="removeItems(questions, rowNumber,card,isGrid,gridId)">
              <fa-icon class="cp" [icon]="icons.faTrash"></fa-icon>
              Delete
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #textarea let-que="que" let-questions="questions" let-card="card" let-rowNumber="rowNumber" let-isGrid="isGrid" let-gridId="gridId"> 
  <div class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
  </div>
  <div *ngIf="que.dataType == 'textarea' && isEditing" class="input-preview">
    <textarea placeholder="Enter answer" [(ngModel)]="que.answer" name="answer" ></textarea>
  </div>
  <ul *ngIf="que.isExpanded && !isEditing">
    <div class="images flex" *ngIf="que.images?.length > 0">
      <div class="flex" *ngFor="let imgURL of que.images; let ind = index;">
        <img *ngIf="que.questionImage" [src]="imgURL" width="50" alt="" />
        <fa-icon class="cp" [icon]="icons.faTimes" (click)="removeItems(que.images,rowNumber, ind,card,isGrid)"></fa-icon>
      </div>
    </div>
    <li class="flex align-center justify-end">
      <div class="p-rel">
        <!-- <fa-icon class="cp" [icon]="icons.faImage"></fa-icon> -->
        <input #file type="file" accept='image/*' (change)="preview(que, file.files)" />
        <fa-icon class="cp" [icon]="icons.faEllipsisH" (click)="toggleEditQuestion(que)"></fa-icon>
        <div class="dropdown createQuestion" (mouseleave)="toggleEditQuestion(que)" *ngIf="que.editQuestion">
          <ul>
            <li (click)="duplicateQuestion(que, questions)">
              <fa-icon class="cp" [icon]="icons.faClone"></fa-icon>
              Duplicate
            </li>
            <li (click)="removeItems(questions, rowNumber,card,isGrid,gridId)">
              <fa-icon class="cp" [icon]="icons.faTrash"></fa-icon>
              Delete
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #statement let-que="que" let-questions="questions" let-card="card" let-gridId="gridId" let-isGrid="isGrid">
  <div class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
  </div>
  <div *ngIf="que.dataType == 'statement' && isEditing" class="input-preview">
 <input placeholder="Enter answer" [(ngModel)]="que.answer" name="answer" />
   </div>
</ng-template>

<ng-template #signature let-que="que" let-questions="questions"
let-card="card" let-isGrid="isGrid" let-gridId="gridId" let-rowNumber="rowNumber">
  <div class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
   </div>
   <ul *ngIf="que.isExpanded && !isEditing">
    <div class="images flex" *ngIf="que.images?.length > 0">
      <div class="flex" *ngFor="let imgURL of que.images; let ind = index;">
        <img *ngIf="que.questionImage" [src]="imgURL" width="50" alt="" />
        <fa-icon class="cp" [icon]="icons.faTimes" (click)="removeItems(que.images,rowNumber, ind,card,isGrid)"></fa-icon>
      </div>
    </div>
    <li class="flex align-center justify-end">
      <div class="p-rel">
 		<input #file type="file" accept='image/*' (change)="preview(que, file.files)" />
               <fa-icon class="cp" [icon]="icons.faEllipsisH" (click)="toggleEditQuestion(que)"></fa-icon>
        <div class="dropdown createQuestion" (mouseleave)="toggleEditQuestion(que)" *ngIf="que.editQuestion">
          <ul>
            <li (click)="duplicateQuestion(que, questions)">
              <fa-icon class="cp" [icon]="icons.faClone"></fa-icon>
              Duplicate
            </li>
            <li (click)="removeItems(questions, rowNumber,card,isGrid,gridId)">
              <fa-icon class="cp" [icon]="icons.faTrash"></fa-icon>
              Delete
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</ng-template>


<ng-template #fileupload let-que="que" let-questions="questions" let-gridId="gridId" let-isGrid="isGrid" let-card="card" let-rowNumber="rowNumber">
  <div class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
   </div>
   <ul *ngIf="que.isExpanded && !isEditing">
    <div class="images flex" *ngIf="que.images?.length > 0">
      <div class="flex" *ngFor="let imgURL of que.images; let ind = index;">
        <img *ngIf="que.questionImage" [src]="imgURL" width="50" alt="" />
        <fa-icon class="cp" [icon]="icons.faTimes" (click)="removeItems(que.images, rowNumber,ind,card,isGrid)"></fa-icon>
        questions, rowNumber,card,isGrid,gridId
      </div>
    </div>
    <li class="flex align-center justify-end">
      <div class="p-rel">
		 <input #file type="file" accept='image/*' (change)="preview(que, file.files)" />
               <fa-icon class="cp" [icon]="icons.faEllipsisH" (click)="toggleEditQuestion(que)"></fa-icon>
        <div class="dropdown createQuestion" (mouseleave)="toggleEditQuestion(que)" *ngIf="que.editQuestion">
          <ul>
            <li (click)="duplicateQuestion(que, questions)">
              <fa-icon class="cp" [icon]="icons.faClone"></fa-icon>
              Duplicate
            </li>
            <li (click)="removeItems(questions, rowNumber,card,isGrid,gridId)">
              <fa-icon class="cp" [icon]="icons.faTrash"></fa-icon>
              Delete
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #dte let-que="que" let-card="card">
  <div class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
   </div>
</ng-template>
<ng-template #multipleChoice let-que="que" let-questions="questions" let-card="card" let-rowNumber="rowNumber" let-isGrid="isGrid" let-gridId="gridId">
  <div class="multiple-choice" @fadeIn>
    <div (onfocus)="expandCard(que,card)">
        <ng-container [ngTemplateOutlet]="statement"
                      [ngTemplateOutletContext]="{que: que,card:card}">
        </ng-container>
    </div>
      <div class="preview-list" *ngIf="isEditing">
        <div class="flex">
          <img *ngIf="que.questionImage" [src]="que.questionImage" width="100%" alt="" />
        </div>
        <ul>
          <li [ngClass]="{'selected': option.selected}" class="{{que.dataType + '-Elem'}}" (click)="selectOption(que, option, k)" *ngFor="let option of que.options;let k = index;"> {{option.value}} </li>
        </ul>
      </div>
      <ul *ngIf="que.isExpanded && !isEditing">
        <div class="images flex" *ngIf="que.images?.length > 0">
          <div class="flex" *ngFor="let imgURL of que.images; let ind = index;">
            <img *ngIf="que.questionImage" [src]="imgURL" width="50" alt="" />
            <fa-icon class="cp" [icon]="icons.faTimes" (click)="removeItems(que.images, ind,card,isGrid,gridId)"></fa-icon>
          </div>
        </div>
        <li class="flex align-center justify-between option" *ngFor="let option of que.options;let k = index;">
 			<input type="text" autocomplete="off" placeholder="Enter Options" (focusout)="updateData()" [(ngModel)]="option.value" name="option" />
                   <div style="width:50%">
            <fa-icon style="float: right;" class="cp" [ngClass]="{'disabled': option == ''}" [icon]="icons.faMinus" (click)="removeOption(k, que.options)"></fa-icon>
			<fa-icon style="float:right" class="cp" [ngClass]="{'disabled': option == ''}" [icon]="icons.faPlus" (click)="addOption(k,que.options)"></fa-icon>
          </div>
        </li>
        <li class="flex align-center justify-end">
          <div class="p-rel">
            <!--<fa-icon class="cp" (click)="expandCard(que)" [icon]="icons.faWrench"></fa-icon>-->
            <!-- <fa-icon class="cp" [icon]="icons.faImage"></fa-icon> -->
 			<input #file type="file" accept='image/*' (change)="preview(que, file.files)" />
                       <fa-icon class="cp" [icon]="icons.faEllipsisH" (click)="toggleEditQuestion(que)"></fa-icon>
            <div class="dropdown createQuestion" (mouseleave)="toggleEditQuestion(que)" *ngIf="que.editQuestion">
              <ul>
                <li (click)="duplicateQuestion(que, questions)">
                  <fa-icon class="cp" [icon]="icons.faClone"></fa-icon>
                  Duplicate
                </li>
                <li (click)="removeItems(questions, rowNumber,card,isGrid,gridId)">
                  <fa-icon class="cp" [icon]="icons.faTrash"></fa-icon>
                  Delete
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
</ng-template>

<ng-template #matrix let-que="que" let-questions="questions" let-card="card" let-rowNumber="rowNumber" let-isGrid="isGrid" let-gridId="gridId">
  <div @fadeIn>
    <div (onfocus)="expandCard(que,card)">
        <ng-container [ngTemplateOutlet]="statement"
                      [ngTemplateOutletContext]="{que: que,card:card}">
        </ng-container>
    </div>
      <div class="preview-list" *ngIf="isEditing">
        <div class="flex">
          <img *ngIf="que.questionImage" [src]="que.questionImage" width="100%" alt="" />
        </div>
        <ul>
          <li [ngClass]="{'selected': option.selected}" class="{{que.dataType + '-Elem'}}" (click)="selectOption(que, option, k)" *ngFor="let option of que.options;let k = index;"> {{option.value}} </li>
        </ul>
      </div>
      <ul *ngIf="que.isExpanded && !isEditing">
        <div class="images flex" *ngIf="que.images?.length > 0">
          <div class="flex" *ngFor="let imgURL of que.images; let ind = index;">
            <img *ngIf="que.questionImage" [src]="imgURL" width="50" alt="" />
            <fa-icon class="cp" [icon]="icons.faTimes" (click)="removeItems(que.images, ind,card,isGrid,gridId)"></fa-icon>
          </div>
        </div>

          <div>
             Set row type
            <!-- <select  aria-label="Select"[(ngModel)]="rowType" (ngModelChange)="onChangeSubQuesType($event,que,questions)" class="ddlQueTypeBackground"> -->
              <select  aria-label="Select"[(ngModel)]="que.subQuestions[0].dataType" (ngModelChange)="onChangeSubQuesType($event,que,questions)" class="ddlQueTypeBackground">
              <option *ngFor="let data of matrixQuesTypes;" [value]="data.type">{{data.title}}</option>
           </select>
         </div>
         <div>
          <div>Rows</div>
          <li class="flex align-center justify-between option" *ngFor="let option of que.subQuestions;let k = index;">
          <div style="display: flex;width: 100%;">
            <input type="text"  (click)="expandCard(option,card)" autocomplete="off" placeholder="Enter Row Title" (focusout)="updateData()" [(ngModel)]="option.questionText" name="option" />
          <div style="width:50%">
           <fa-icon style="float: right;" class="cp" [ngClass]="{'disabled': option == ''}" [icon]="icons.faMinus" (click)="removeSubQuestion(que,k, option,questions)"></fa-icon>
           <fa-icon style="float:right" class="cp" [ngClass]="{'disabled': option == ''}" [icon]="icons.faPlus" (click)="addSubQuestion(que,k,option,questions)"></fa-icon>
          </div>
        </div>
           </li>
          <div>

          </div>
        </div>
        <br>
        <div>Columns </div>
      <li class="flex align-center justify-between option" *ngFor="let option of que.options;let k = index;">
 			<input type="text" autocomplete="off" placeholder="Enter Column Title" (focusout)="updateData()" [(ngModel)]="option.value" name="option" />
                   <div style="width:50%">
            <fa-icon style="float: right;" class="cp" [ngClass]="{'disabled': option == ''}" [icon]="icons.faMinus" (click)="removeOption(k, que.options)"></fa-icon>
			<fa-icon style="float:right" class="cp" [ngClass]="{'disabled': option == ''}" [icon]="icons.faPlus" (click)="addOption(k,que.options)"></fa-icon>
          </div>
      </li>
        <li class="flex align-center justify-end">
          <div class="p-rel">
            <!--<fa-icon class="cp" (click)="expandCard(que)" [icon]="icons.faWrench"></fa-icon>-->
            <!-- <fa-icon class="cp" [icon]="icons.faImage"></fa-icon> -->
 			<input #file type="file" accept='image/*' (change)="preview(que, file.files)" />
                       <fa-icon class="cp" [icon]="icons.faEllipsisH" (click)="toggleEditQuestion(que)"></fa-icon>
            <div class="dropdown createQuestion" (mouseleave)="toggleEditQuestion(que)" *ngIf="que.editQuestion">
              <ul>
                <li (click)="duplicateQuestion(que, questions)">
                  <fa-icon class="cp" [icon]="icons.faClone"></fa-icon>
                  Duplicate
                </li>
                <li (click)="removeItems(questions, rowNumber,card,isGrid,gridId)">
                  <fa-icon class="cp" [icon]="icons.faTrash"></fa-icon>
                  Delete
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
</ng-template>


<ng-template #welcome let-card="card" let-que="que">
  <div (click)="expandData(que)">
    <app-welcome [testName]="card.sectionName"></app-welcome>
  </div>
</ng-template>
<ng-template #thankyou let-card="card">
    <div (click)="expandData(card)">
  <app-thank-you></app-thank-you>
    </div>
</ng-template>
<ng-template #dropdown let-que="que" let-card="card">
  <ng-container [ngTemplateOutlet]="statement"
                [ngTemplateOutletContext]="{que: que}">
  </ng-container>
  <app-dropdown [dataList]="que.options"
                [allowMultipleSelect]="true"></app-dropdown>
</ng-template>

<ng-template #rating let-que="que" let-isGrid="isGrid" let-gridId="gridId" let-card="card">
  <div class="flex align-center que-title" @fadeIn>
    <label class="{{que.dataType}}">
      {{que.questionTextShort | slice : 0 : 2 }}
    </label>
    <span *ngIf="isEditing"> {{que.questionText}} </span>
    <input *ngIf="!isEditing" type="text" (focusout)="updateData()" autocomplete="off" placeholder="Enter Question" [(ngModel)]="que.questionText" name="questionText" (click)="expandCard(que,card)" />
  </div>
  <app-rating-preview [ratingConfig]="que" [isEditing]="true" (updateConfig)="updateRatingConfig($event, que)"></app-rating-preview>
</ng-template>

<ng-template #gridRender let-que="que" let-card="card" let-rowNumber="rowNumber"> 
  <!-- Code for Grid Control-->
  
  <div *ngIf="card.gridQuestions.lenght!=0" style="overflow-x:auto;">
    <!-- <table title="" style="width: 100%;">            
       <tr *ngFor="let grid of card.gridQuestions;let grdtl = gridCount;">  
         <!- - <p>gridSeq- {{grid.sequenceNumber}}</p>  - ->
        <!- - <table *ngIf="grid.sequenceNumber==rowNumber+1"  style="border:black;border:groove;">        - ->
          <table  *ngIf="grid.sequenceNumber==que.sequenceNumber && grid.isDeleted==false"  style="border:black;border:groove;width:100%;">       
          <div (onfocus)="expandCard(que,card)">
          <div class="flex align-center que-title" @fadeIn>
            <label class="tbl {{que.dataType}}">
              {{que.questionTextShort | slice : 0 : 2 }}
            </label>
            <input type="text" [(ngModel)]="que.questionText" placeholder="Enter grid title" value={{que.questionText}}/>
           </div>
         </div>
         <td *ngFor="let que of grid.questions;let z = index;">
           <div class="que-option cp" [ngClass]="{'expanded': que.isExpanded || isEditing}"  *ngIf="que.isDeleted===null||que.isDeleted==false" @fadeIn>
             <ng-container [ngTemplateOutlet]="
             que.dataType === 'textbox'? textbox : 
             que.dataType === 'textarea'? textarea : 
             que.dataType === 'dte' ? dte :
             (que.dataType === 'multipleChoice' || que.dataType === 'checkbox' || que.dataType === 'radiobuttons' || (que.dataType === 'dropdown' && !isEditing)) ? multipleChoice :
             que.dataType === 'welcome' ? welcome :
             que.dataType === 'thankyou' ? thankyou :
             que.dataType === 'rating' ? rating :   
             que.dataType==='signature'?signature:    
             que.dataType==='fileupload'?fileupload: 
             (que.dataType === 'dropdown' && isEditing) ? dropdown :
              que.dataType === 'table' ? gridRender : ''"
             [ngTemplateOutletContext]="{que: que, card: card, questions: card.questions, rowNumber: z,isGrid:true,gridId:grid.gridId}">
             </ng-container>
           </div>
         </td>         
         <div class="que-option add-question flex justify-between" *ngIf="!isEditing">
          <fa-icon class="cp" (click)="toggleQuestionTypeGrid(grid)" [icon]="icons.faPlus"></fa-icon>
          <!- - <button type="button" class="delete-btn cp" (click)="deleteGridQuestion(card,grid.gridId,rowNumber)">DELETE</button>       - ->
          <button type="button" class="delete-btn cp" (click)="removeItems(card.questions,rowNumber,card,false)">DELETE</button>       
          <div id="gridModal" class="modal" [ngStyle]="{'display': grid.isMenuVisible && IsGridQuestionMenu ? 'block' : 'none'}">


            <div style="position: relative !important;" class="dropdown  modal-content" (mouseleave)="toggleQuestionTypeGrid(grid)">
              <div class="flex">
                <div class="que-types">
                  <p id="title" style="margin:0px"><b>Choose A Question Type</b></p>
                  <ul class="ulflex">
                    <li class="flex align-center liflex" *ngFor="let type of queTypes;"
                        (mouseenter)="setQuestionContent(type)"
                        (click)="addNewColumnInGrid(card.questions,card,grid.gridId)">
                      <span [ngStyle]="{'background-color': type.colorCode}"> {{type.icon}} </span>
                      <span> {{type.title}} </span>
                    </li>
                  </ul>
                </div>
              
              </div>
            </div>
          
          </div>
          </div>
        </table>             
       </tr>
     </table>  -->
   </div>
  </ng-template>
   <!-- End Grid Code-->


<app-modal class="draft" [modalSize]="modalSize" [modalText]="modalText" *ngIf="!hidePopUp" (modalClose)="close($event)">
  <div class="modal-body-extended">
    <p class="modelpopupbody">
    Are you sure you want to draft the survey without publishing?
    </p>
    <br>
  </div>
  <div class="modal-footer-extended" style="margin-top:6%;">

    <div class="row">
      <div class="column"></div>
      <div class="column">
        <app-button [btnText]="btncloseText" [btnStyle]="btnWithText" [btnType]="btnRect" [btnColor]="btnBlue" [btnSize]="btnMedium" (click)="close($event)"></app-button> &nbsp;
      </div>
      <div class="column">
        <app-button [btnText]="btnText" [btnStyle]="btnWithText" [btnType]="btnRect" [btnColor]="btnBlue" [btnSize]="btnMedium" (click)="publish('D')"></app-button> &nbsp;
      </div>
    </div>

  </div>
</app-modal>
